export const BG_PRIMARY = 'rgba(255,255,255,1)';
export const BG_SECONDARY = 'rgba(187,187,187,0.67)';
export const BG_SECONDARY2 = 'rgba(187,187,187,1)';
export const BG_ALTERNATIVE = 'rgba(72,68,69,1)';

export const BG_STEP_RSVP = 'rgba(148,141,136,1)';

export const TEXT_PRIMARY = 'rgba(22,21,21,1)';
export const TEXT_SECONDARY = 'rgba(0,0,0,1)';
export const TEXT_ALTERNATIVE = 'rgba(250,250,250,1)';

export const BTN_NAVIGATION_COLOR = '#997a5e';
export const NAVIGATION_ICON_COLOR = '#FFFFFF';

export const HEADING_STYLES = {
  fontFamily: 'heading',
  fontWeight: 'light',
  fontSize: '4xl',
};

export const HEADING_ALTERNATIVE_STYLES = {
  fontFamily: 'headingAlternative',
  fontWeight: 'bold',
  letterSpacing: '2px',
  textTransform: 'uppercase',
  fontSize: 'md',
  textAlign: 'center',
};

export const HASHTAG_STYLE = {
  fontFamily: 'body',
  fontWeight: 'light',
  fontSize: '3xl',
  fontStyle: 'italic',
};

export const BUTTON_PROPS = {};

export const DEFAULT_BUTTON_PROPS = {
  fontWeight: 'light',
  size: 'sm',
  fontSize: 'xl',
  padding: '17px 40px',
  fontStyle: 'italic',
  type: 'button',
  bgColor: 'bgSecondary',
  color: 'secondaryColorText',
  fontFamily: 'body',
  borderRadius: '0',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: '#1A1B1D',
};
